module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metabase/code/metabase-org/releases/release-2023-05-24-x.46.4/metabase-1.46.4/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metabase/code/metabase-org/releases/release-2023-05-24-x.46.4/metabase-1.46.4/node_modules/source-map-loader/dist/cjs.js!/Users/metabase/code/metabase-org/releases/release-2023-05-24-x.46.4/metabase-1.46.4/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}